import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import sessionsService from '../services/sessionsServices';
import { queryKeys, sessionsInvalidateKey } from './queryKeys';

export function useSidebarSessions(payload, options = {}) {
  return useQuery({
    queryKey: queryKeys.sessions.sidebar(payload),
    queryFn: () => sessionsService.getSessionsList(payload),
    staleTime: 60 * 1000,
    refetchOnWindowFocus: false,
    ...options,
  });
}

export function useCreateSession(options = {}) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: payload => sessionsService.createSession(payload),
    onSuccess: (...args) => {
      queryClient.invalidateQueries({ queryKey: sessionsInvalidateKey });
      options.onSuccess?.(...args);
    },
    onError: options.onError,
  });
}

export function useDeleteSession(options = {}) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: payload => sessionsService.deleteSession(payload),
    onSuccess: (...args) => {
      queryClient.invalidateQueries({ queryKey: sessionsInvalidateKey });
      options.onSuccess?.(...args);
    },
    onError: options.onError,
  });
}

export function useUpdateSession(options = {}) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: payload => sessionsService.updateSession(payload),
    onSuccess: (...args) => {
      queryClient.invalidateQueries({ queryKey: sessionsInvalidateKey });
      options.onSuccess?.(...args);
    },
    onError: options.onError,
  });
}
